var map = {
	"./admin_settings.png": 1705,
	"./catalog.png": 1706,
	"./catalogWhite.png": 1707,
	"./catalog_orders.png": 1708,
	"./cms.png": 1709,
	"./component-fields/Asset.png": 1710,
	"./component-fields/Blocks.png": 1711,
	"./component-fields/Boolean.png": 1712,
	"./component-fields/Date-time.png": 1713,
	"./component-fields/LInk.png": 1714,
	"./component-fields/Markdown.png": 1715,
	"./component-fields/Multi asset.png": 1716,
	"./component-fields/Multi options.png": 1717,
	"./component-fields/Number.png": 1718,
	"./component-fields/Richtext.png": 1719,
	"./component-fields/Single options.png": 1720,
	"./component-fields/Table.png": 1721,
	"./component-fields/Text area.png": 1722,
	"./component-fields/Text.png": 1723,
	"./components.png": 1724,
	"./configuration.png": 1725,
	"./contents.png": 1726,
	"./crm.png": 1727,
	"./custom_order.png": 1728,
	"./customer_credits.png": 1729,
	"./customer_list.png": 1730,
	"./dashboard.png": 1731,
	"./finance.png": 1732,
	"./home.png": 1733,
	"./integrations.png": 1734,
	"./inventory-transfers.png": 1735,
	"./invoice-list.png": 1736,
	"./layaway.png": 1737,
	"./move.png": 1738,
	"./new_sale.png": 1739,
	"./orders.png": 1740,
	"./outgoing-consignments.png": 1741,
	"./payment-methods/amex.png": 1112,
	"./payment-methods/discover.png": 1111,
	"./payment-methods/mastercard.png": 1110,
	"./payment-methods/visa.png": 1109,
	"./payments.png": 1742,
	"./register.png": 1743,
	"./repair_center.png": 1744,
	"./reports.png": 1745,
	"./services.png": 1746,
	"./trade_in_center.png": 1747
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1360;